import { View } from "../../../../core/view/index";
import { LazyTemplate, Template } from "../../../../core/template/index";

export interface MenuActionOptions
{
    title: string;
    iconClass: string;
    vibrateOnClick?: boolean;
    hash?: string;
    disabled?: boolean;
}

export default class MenuActionItem extends View
{
    protected iconClass = '';
    protected title = '';
    protected vibrateOnClick: boolean;
    protected disabled: boolean;
    
    /** Optional hash where the app is routed when the main menu action is clicked. */
    public hash: string;

    public template: LazyTemplate = Template.inline(`
    <div data-bind-class="disabledClass" class="menu-action" data-bind-click="onClick">
        <header><i class="icon {{=it.iconClass}}"></i></header>
        <main>{{=it.title}}</main>
        <footer></footer>
    </div>
    `);

    constructor(options: MenuActionOptions)
    {
        super();
        this.title = options.title;
        this.iconClass = options.iconClass;
        this.hash = options.hash;
        this.vibrateOnClick = options.vibrateOnClick;
        this.disabled = options.disabled ? true : false;
        if (this.disabled) {
            this.data.disabledClass = 'disabled';
        }
    }

    public onClick(e: MouseEvent)
    {
        if (this.disabled) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        this.trigger('click');
        if (this.vibrateOnClick)
        {
            navigator.vibrate(100);
        }

        if (this.hash != null)
        {
            location.hash = this.hash;
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }
}
